export const VIEW_ENTER = 'slip/VIEW_ENTER';
export const DISABLE_ADD = 'slip/DISABLE_ADD';
export const ADD_SLIP_NUMBER = 'slip/ADD_SLIP_NUMBER';

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const disableAdd = () => ({
  type: DISABLE_ADD
});

export const addSlip = (slipId) => ({
  type: ADD_SLIP_NUMBER,
  slipId
});
